export default function (value) {
  if (!value) {
    value = 0
  }
  value = value * 100
  value = Math.round(value * Math.pow(10, 0)) / Math.pow(10, 0)
  value = value + '%'

  return value
}
